import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

DateTitle.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string,
  fontWeight: PropTypes.string,
  fontSize: PropTypes.string
}


const StyleDateTitle = styled.div`
  color: ${(props) => props.color};
  font-weight: ${(props) => props.fontWeight};
  font-size: ${(props) => props.fontSize};
  letter-spacing: 0.1em;
  font-variant-numeric: tabular-nums;
  font-feature-settings: "tums";
`

/**
 * サブタイトル
 * @param {node} children 子要素
 * @param {string} color 文字の色
 * @param {string} fontWeight 文字の太さ
 * @param {string} fontSize 文字の大きさ
 * @returns 
 */
export default function DateTitle(props){
  const { children, color, fontWeight, fontSize } = props
  return(
    <StyleDateTitle
      color={color}
      fontWeight={fontWeight}
      fontSize={fontSize}
    >
      {children}
    </StyleDateTitle>
  )
}
